import React, { useState } from "react";
import PortafolioList from "./PortafolioList";
import LoadSimple from "../LoadSimple";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
const TablePortafolio = ({
  pageActual,
  limitList,startLimit,
  devices,
  setEditActive,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  exceptions,
  languaje,
  mode
}) => {
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
        <div className="field-head-table-mantenimiento field-medium">{capitalizeFirstLetter(lang[languaje]['exception'])} ID</div>
        <div className="field-head-table-mantenimiento field-larger">Host ID</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}}>Host </div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</div>
        <div className="field-head-table-mantenimiento field-larger">{capitalizeFirstLetter(lang[languaje]['agencia'])}</div>
        <div className="field-head-table-mantenimiento field-larger">{capitalizeFirstLetter(lang[languaje]['tiempoActivo'])}</div>
        <div className="field-head-table-mantenimiento field-larger"></div>
      </div>
      </div>
      <div className="body-table-cis-gs">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <PortafolioList

          setEditActive={setEditActive}
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            exceptions={exceptions}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
          ></PortafolioList>
        )}
      </div>
    </div>
  );
};

export default TablePortafolio;
